import { Title } from '@app/components/core/typography/Title'
import Column from '@app/components/layout/Column'
import { useAuthState, useClient } from '@based/sdk/react'
import { i18n } from '@i18n/index'
import { useLanguage } from '@i18n/useLanguage'
import { useEffect, useState } from 'react'
import defaultProjectPicture from '@app/assets/defaultProjectPicture.png'
import { useLocation } from 'wouter'
import { pages } from '@app/util/links'
import { Button } from '@app/components/core/button/Button'
import { DashboardListCard } from '@app/components/blocks/card/DashboardListCard'
import { INITIATIVE_USER_ROLES } from '@schema/initiative'
import { Text } from '@app/components/core/typography/Text'
import listInitiativeFunction from 'functions/app/dashboard/profile/initiative/list/based.config'
import { DahsboardListInitiativeModel } from 'functions/app/dashboard/profile/initiative/list'
import { labelAddressBuilder } from '@app/util/helpers'

export const FollowedInitiatives = () => {
  const [language, _setLanguage] = useLanguage()
  const translations = i18n.languages[language].app.dashboard.followed
  const commonTranslations = i18n.languages[language].app.common
  const client = useClient()
  const authState = useAuthState()
  const [followedInitiatives, setFollowedInitiatives] = useState<
    DahsboardListInitiativeModel[]
  >([])
  const [_, navigate] = useLocation()

  useEffect(() => {
    const close = client
      .query(listInitiativeFunction.name, {
        userId: authState.userId,
        role: INITIATIVE_USER_ROLES.follower,
        includeAllInitiativeUsers: false,
      })
      .subscribe((result) => {
        setFollowedInitiatives(result)
      })
    return () => close()
  }, [client, authState.userId])

  const unfollow = async (initiativeId: number) => {
    await client.call('unfollow-initiative', {
      initiativeId: initiativeId,
    })
  }

  if (followedInitiatives.length === 0) {
    return (
      <Column alignItems="stretch">
        <Title.H4 style={{ marginBottom: '0' }}>
          {translations.initiatives}
        </Title.H4>
        <Text.Medium color="var(--gray-300)">
          {translations.youFollowNoInitiatives}
        </Text.Medium>
      </Column>
    )
  }

  return (
    <Column alignItems="stretch">
      <Title.H4 style={{ marginBottom: '0' }}>
        {translations.initiatives}
      </Title.H4>
      {followedInitiatives.map((initiative) => (
        <DashboardListCard
          key={initiative.slug}
          title={initiative.title}
          tag={commonTranslations.initiativeUserRole[initiative.users[0].$role]}
          image={initiative.images?.[0]?.src ?? defaultProjectPicture}
          location={labelAddressBuilder(
            initiative.location.address,
            commonTranslations.notSpecified,
          )}
          status={initiative.phase.name}
          onClick={() => navigate(pages.initiative(initiative.slug))}
          action={
            <Button
              variant="secondary"
              size="small"
              label={translations.unfollow}
              onClick={(e) => {
                e.stopPropagation()
                void unfollow(initiative.id)
              }}
            />
          }
        />
      ))}
    </Column>
  )
}
